import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding":"10px 20px"} }

import ListApproval from '@/views/dashboard/data-safe/anti-external-control/components/ListApproval.vue';
import { SensitiveService } from '@/views/dashboard/data-safe/anti-external-control/service';
import { useReflectiveInjector } from '@tanbo/vue-di-plugin';
import { ref, watch } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Approval',
  props: {
  id: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props
const list = ref([])
const injector = useReflectiveInjector([SensitiveService])
const sensitiveService = injector.get(SensitiveService)
const getSensitiveWordsFileOutgoing = sensitiveService.getSensitiveWordsFileOutgoing.bind(sensitiveService)
const getSensitiveWordsFileOutgoingList = async () => {
  const result = await getSensitiveWordsFileOutgoing({ record_id: props.id,page:1,limit: 10 })
  list.value = result.data
}
watch(() => props.id, (nv) => {
  if (!nv) return
  getSensitiveWordsFileOutgoingList()
}, {
  immediate: true,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ListApproval, { list: list.value }, null, 8, ["list"])
  ]))
}
}

})